import wx from 'weixin-js-sdk'
import { getWXAccessToken, getFilterList } from "@/api/index"

let img_Url = ""

const getShareImg = async () => {
 let _params = {
  page: 1,
  pageSize: 1,
  worksheetId: "689ea0d3e578de251c36c03c",
 }
 const _res = await getFilterList(_params)
 if (_res.code == 200) {
  if (_res.data && _res.data.length > 0) {
   let item = _res.data[0]
   if (item["file-upload16864723"] && item["file-upload16864723"].length > 0) {
    let file = item["file-upload16864723"][0]
    img_Url = `${location.origin}${file.url}`
   }
  }
 }

}


export const useWxShare = async (_title, _desc, _link, _imgUrl) => {
 if (!img_Url) {
  await getShareImg()
 }
 // 这里可以添加分享逻辑
 let wxUrl = location.href.split('#')[0]
 let res = await getWXAccessToken(wxUrl)
 let data = res.data
 if (wx) {
  try {
   wx.config({
    debug: false, // 开启调试模式,微信打开时会一顿弹窗告诉你 ok 还是 ko
    appId: data.appId, // 企业号的唯一标识
    timestamp: data.timestamp, // 生成签名的时间戳
    nonceStr: data.nonceStr, // 生成签名的随机串
    signature: data.signature, // 签名
    jsApiList: [
     'checkJsApi', // 检查方法能不能用。
     'updateAppMessageShareData', // 分享给朋友时样式设置
     'updateTimelineShareData' //这个我这用不到，手动触发分享要用
    ] // 必填，需要使用的js接口列表，具体都是怎么回事去看 sdk 文档就行了。
   })


   wx.checkJsApi({
    jsApiList: [
     'updateAppMessageShareData',
     "chooseImage",
     'updateTimelineShareData'
    ], // 看看这俩方法能用不，debug true 时会弹 ok ok。
    success: function () {
     wx.ready(function () {
      wx.updateAppMessageShareData({
       title: _title, // 分享时的标题
       desc: _desc, // 分享描述
       link: _link, // 分享时的链接
       imgUrl: img_Url ? img_Url : _imgUrl,
       success: function () {
        console.log('成功时回调，没有就删了')
       },
       cancel: function () {
        console.log('失败时回调，没有就删了')
       }
      })
      wx.updateTimelineShareData({
       title: _title, // 分享时的标题
       desc: _desc, // 分享描述
       link: _link, // 分享时的链接
       imgUrl: img_Url ? img_Url : _imgUrl,
      })
     })



    },
    fail: (error) => {
     console.log('error', error)
    }
   })
  } catch (error) {
   console.error("微信JS-SDK加载失败", error);
   return;
  }

 }

}
